import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../../visa';
import { of, iif, EMPTY } from "rxjs";
import { delay, mergeMap } from 'rxjs/operators';

interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}
export interface Attachment {
  id?: string;
  file: File;
  fileSRC: string | ArrayBuffer;
  fileAttributes: {
      fileName: string
      size: string
  }
}
@Component({
  selector: 'app-branch-employee-link-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ComponentStore]
})

export class BranchEmployeeLinkEditComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Edit Branch EmployeeLink';
  protected index = 8;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deleteConfirmation$ = this.componentStore.select(state => state.deleteConfirmation);

  apiVisa = AppConfig.apiVisa;
  byteSize = ['Bytes', 'KB', 'MB'];
  attachment: Attachment;
  imageUrl;
  uploadedFile;
  branchGuid;
  form: FormGroup;
  src : any;
  guid;
  deleteConfirmation = false;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  constructor(
    private http: HttpClient,
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });

    this.form = new FormGroup({
      code: new FormControl(),
      name: new FormControl()
    })

    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectEmployee).subscribe(async (resolved: any) => {
      this.form.patchValue({
        code: resolved.employee_code,
        name: resolved.name
      });
    });


    this.subs.sink = this.deleteConfirmation$.pipe(
      mergeMap(a => {
        return iif(() => a, of(a).pipe(delay(3000)), of(EMPTY));
      })
    ).subscribe(resolve => {
      if (resolve === true) {
        this.componentStore.patchState({deleteConfirmation: false});
        this.deleteConfirmation = false;
      }
    });
  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onDelete(){
    if (this.deleteConfirmation) {
      this.branchSettingsStore.dispatch(BranchSettingsActions.deleteEmployeeLinkInit());
      this.deleteConfirmation = false;
      this.componentStore.patchState({deleteConfirmation: false});
    } else {
      this.deleteConfirmation = true;
      this.componentStore.patchState({deleteConfirmation: true});
    }
  }
}
